import barba from '@barba/core';
import { gsap } from 'gsap';
import { enableBodyScroll } from 'body-scroll-lock';

import { elementPosition, replaceBodyClasses, scrollPosition, wait } from '../global/helpers';
import { $Elements, BrowserEvents, Classes, Elements, TransitionDurations, TransitionnableLinks } from '../global/constants';

;(function($) {

	// ---------- Barba Initialisation ----------

	barba.init({
		debug: false,
		preventRunning: true,
		prevent: ({ el }) => !$(el).is(TransitionnableLinks),
		transitions: [{
			sync: true,
			once: async() => $Elements.window.on('load', pageLoaded),
			enter: async() => $Elements.document.one(BrowserEvents.page.transition, pageLoaded),
			leave: async(data) => {

				Elements.MainWrapper.dataset.color = data.next.container.dataset.color;
				Elements.LoadingBar.classList.add(Classes.loading);
				document.body.classList.add(Classes.leaving, Classes.loading);
				data.current.container.classList.add(Classes.leaving);

				if(isGrowingImageLink(data)) {
					await growingImageTransition(data)
				}
				else {
					await defaultTransition(data);
				}

				return true;
			},
			after: async(data) => {

				window.scrollTo(0, 0);
				replaceBodyClasses(data.next);
				$('.' + Classes.transitionClone).remove();
				$Elements.document.trigger(BrowserEvents.page.transition);

				return true;
			}
		}]
	});

	// ---------- Transitions ----------

	function isGrowingImageLink(data) {
		return (typeof data.trigger !== 'string' && data.trigger.getAttribute('target') === 'grow');
	}

	async function defaultTransition(data) {

		Elements.LoadingOverlay.classList.add(Classes.loading);

		const scroll = scrollPosition();
		data.next.container.style.top = scroll.scrollTop + 'px';

		if(document.body.classList.contains(Classes.menuOpen)) {
			document.body.classList.remove(Classes.menuOpen);
			enableBodyScroll(Elements.MenuWrapper);
		}

		await wait(TransitionDurations.page);

		gsap.set(data.current.container, { opacity: 0 });

		await wait(200);

		window.scrollTo(0, 0);
		data.next.container.style.top = 0;

		return true;
	}

	async function growingImageTransition(data) {

		const link = data.trigger.parentNode;
		const windowWidth = window.innerWidth;
		const windowHeight = window.innerHeight;

		const position = elementPosition(link);
		const scroll = scrollPosition();
		const clone = link.cloneNode(true);
		const image = clone.querySelector('.section-image');

		clone.classList.add(Classes.transitionClone);
		clone.classList.remove(Classes.active);

		gsap.set(clone, { ...position });

		link.classList.add(Classes.leaving);

		await wait(TransitionDurations.default);

		document.body.appendChild(clone);

		link.classList.add(Classes.invisible);

		if(image) {

			gsap.to(image, {
				x: 0,
				y: 0,
				autoRound: false,
				duration: TransitionDurations.page * 0.001
			});
		}

		await gsap.to(clone, {
			x: -position.left,
			y: scroll.scrollTop - position.top,
			width: window.innerWidth,
			maxWidth: window.innerWidth,
			height: '100vh',
			autoRound: false,
			duration: TransitionDurations.page * 0.001
		});

		await wait(100);

		return true;
	}

	async function pageLoaded() {

		$Elements.document.trigger(BrowserEvents.page.enter);
		document.body.classList.remove(Classes.loading);
		Elements.MainWrapper.dataset.color = Elements.PageWrapper.dataset.color;
		Elements.MainWrapper.classList.remove(Classes.loading, Classes.initialLoad);
		Elements.LoadingBar.classList.remove(Classes.loading);
		Elements.LoadingOverlay.classList.remove(Classes.loading);

		if(!document.body.classList.contains('disclaimer-open')) {
			$Elements.HeaderWrapper.addClass(Classes.active);
			$('.hero-section').addClass(Classes.active);
		}

		return true;
	}

}(jQuery));
